<template>
  <div class="iDalgo-Section" @click="handleClick">
    <h2 class="iDalgo-Section__Title">{{ title }}<b>{{ cardCounter }}</b></h2>
    <div class="iDalgo-Section__Cards">
      <i-dalgo-card
        v-for="(player, key) in section._players"
        :key="`card-${key}`"
        :picture="player.tUrlPicture"
        :title="player.tNickName"
        :subTitle="player.rTeamName"
        :disabled="!selectable"
        :active="player.selected"
        @click="handleClick(key, $event)" />
    </div>
    <div class="iDalgo-Section__CTA" v-if="isCurrentSection">
      <i-dalgo-button
        :disabled="selectable"
        :loading="isLoading"
        @click="handleNextSection">
        {{ $t('CTA.validate') }}
      </i-dalgo-button>
      <span>{{ $t('section.step', { from: sectionNumber + 1, to: sectionSize }) }}</span>
    </div>
  </div>
</template>

<script>
import iDalgoCard from '@/components/iDalgo-Card'
import iDalgoButton from '@/components/iDalgo-Button'
import { mapGetters } from 'vuex'
import { scrollTo } from '@/services/iframe'
export default {
  name: 'iDalgo-Section',
  components: {
    iDalgoCard,
    iDalgoButton
  },
  props: {
    section: {
      type: Object,
      required: true
    },
    sectionNumber: {
      type: Number,
      required: true
    },
    sectionSize: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      sections: 'sections/getSections',
      env: 'app/getEnv',
      isLoading: 'app/isLoading'
    }),
    isCurrentSection () {
      return parseInt(this.$route.params.step) === parseInt(this.sectionNumber + 1)
    },
    selected () {
      return this.section.selected().length
    },
    cardCounter () {
      return `${this.selected}/${this.section.size}`
    },
    selectable () {
      return this.section.selected().length < this.section.size
    },
    title () {
      return `${this.$t('section.select')} ${this.section.size} ${this.section.name.toLowerCase()}`
    }
  },
  methods: {
    handleClick (key, active) {
      if (this.selectable || !active) {
        this.section.playerState(key, -1)
      }
    },
    handleNextSection () {
      if (!(this.sectionNumber + 1 !== this.sectionSize)) {
        // Save
        this.$store.commit('app/LOADING_UPDATED', true)
        scrollTo(this.$root.$el.offsetTop - this.$root.$el.clientTop, 10)
        const sections = this.sections.map(section => {
          return {
            sectionId: section.id,
            name: section.name,
            size: section.size,
            _players: section._players.filter(player => player.selected)
          }
        })
        const list = {
          templateId: this.$route.params.id,
          _sections: sections
        }
        this.$store.dispatch('sections/saveList', list)
          .then(response => {
            setTimeout(() => {
              localStorage.setItem('playerList.id', response.data.id)
              this.$store.commit('app/LOADING_UPDATED', false)
              this.$store.commit('sections/RESET')
              this.$store.commit('app/ENV_UPDATED', 'showResult')
              this.$router.push({ name: 'my-result', params: { id: response.data.id } })
            }, 1500)
          })
      } else if (!this.selectable) {
        this.$router.push({ name: 'steps', params: { step: this.sectionNumber + 2 } })
        this.$store.commit('sections/CURRENT_SECTION_UPDATED', this.sectionNumber + 1)
      }
    }
  },
  mounted () {
    if (parseInt(this.$route.params.step) !== 1 || this.env === 'newListFromResult') {
      scrollTo((this.$el.offsetTop - this.$el.clientTop) - 120, 600)
    }
  }
}
</script>

<style lang="scss">
.iDalgo-Section {

  margin-bottom: 40px;

  &__Cards {
    display: flex;
    flex-flow: row;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
  }

  &__Title {
    font-family: "source_sans_prosemibold", sans-serif;
    color: #35312E;
    font-size: 26px;
    margin-bottom: 40px;

    b {
      float: right;
    }
  }

  &__CTA {
    display: flex;
    margin: 32px auto;
    flex-flow: column;
    align-items: center;

    .iDalgo-Button {
      margin-bottom: 16px;
    }

    span {
      color: #000000;
      font-family: "source_sans_proregular", sans-serif;
      font-size: 16px;
      line-height: 20px;
      text-align: center;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/iDalgo-Section.vue